import { render } from "./Ministop.vue?vue&type=template&id=e5ef255e"
import script from "./Ministop.vue?vue&type=script&setup=true&lang=js"
export * from "./Ministop.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/Ministop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5ef255e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5ef255e', __exports__)) {
    api.reload('e5ef255e', __exports__)
  }
  
  module.hot.accept("./Ministop.vue?vue&type=template&id=e5ef255e", () => {
    api.rerender('e5ef255e', render)
  })

}


export default __exports__